/* eslint-disable */
import React from 'react'
import { cancelCriterionCReassessmentRequest, confirmCriterionC } from 'api/criterionC'
import AssessIcon from 'assets/icons/assess-icon'
import CalendarIcon from 'assets/icons/calendar-icon'
import CancelIcon from 'assets/icons/cancel-icon16px'
import ConfirmIcon from 'assets/icons/confirm-icon'
import DropdownIndicatorIconClosed from 'assets/icons/dropdown-indicator-closed24px'
import DropdownIndicatorIconOpen from 'assets/icons/dropdown-indicator-opened24px'
import ReassessIcon from 'assets/icons/reassess-icon'
import RejectIcon from 'assets/icons/reject-icon'
import RemoveIcon from 'assets/icons/remove-icon'
import Button from 'components/Button'
import FlowRequestModal from 'components/FlowRequestModal'
import Modal from 'components/Modal'
import Tooltip from 'components/Tooltip'
import { defaultSiteProposalValidationResults } from 'constants/defaultSiteProposalValidationResults'
import { reassessmentTriggerReasons } from 'constants/reassessmentTriggerReasons'
import { INDIVIDUAL_ROLE_ID, SECRETARIAT_ROLE_ID, BIRDLIFE_SECRETARIAT_ROLE_ID } from 'constants/roles'
import { SITE_STATUS_DRAFT_ID, SITE_STATUS_NOMINATED_ID } from 'constants/siteStatuses'
import ActionsMenu from 'features/ActionMenu'
import PulsingNotification from 'features/PulsingNotification'
import { ProfileContext } from 'providers/profile'
import { SiteContext } from 'providers/site'
import { useContext, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { showErrorToast } from 'utils/toast'
import {
  EcosystemActionMenuWrapper,
  EcosystemCalendarDateText, EcosystemCalendarDivider, EcosystemCalendarIconWrapper,
  EcosystemConfirmDeclineIcon,
  EcosystemHeaderIcon,
  EcosystemHeaderIconWrapper,
  EcosystemHeaderNavbarHalfSide,
  EcosystemHeaderNavbarIconWrapper,
  EcosystemHeaderNavbarWrapper,
  EcosystemHeaderTitle, EcosystemLastReassessmentCalendarWrapper,
  EcosystemsCancelIconWrapper,
  EcosystemToggleWrapper,
  EcoSystemValidationIcon, EcosystemValidationIconWrapper
} from '../EcosystemData/style'

const formattedRejectIconTooltipHint = (item) => {
  return item.trigger_reason_id.map((element) => {
    return reassessmentTriggerReasons.find((elementId) => {
      return elementId.id === Number(element)
    }).name
  })
}


const tooltipXOffset = 0
const tooltipYOffset = -16
const dateOptions = {
  year: "numeric",
  month: "short",
  weekday: "short",
  day: "numeric",
  hour: "numeric",
  minute: "numeric",
  second: "numeric",
  hour12: true // This is the line of code we care about here
  /*
      false: displays 24hs format for time
      true: displays 12, AM and PM format
  */
};
const criterionCAccordionHeader = ({ isOpen, item, openRemoveCriterionCModal, getCriterionCs, toggleAccordion, lastItem, newTriggers = false, oldTriggers = false }) => {
  const { site, siteProposalFieldValidation, isEditable } = useContext(SiteContext)
  const { profile } = useContext(ProfileContext)
  const isIndividualUser = profile.Role.id === INDIVIDUAL_ROLE_ID
  const dateToShow = item.updated_at ? new Date(item.updated_at) : new Date()
  const [isCancelOpen, setIsCancelOpen] = useState(false)
  const [criterionCToCancel, setCriterionCToCancel] = useState(null)

  const handleCriterionCAction = async (isApproved) => {
    await confirmCriterionC(item.site_ecointegrity_history_id || item.site_ecointegrity_id, isApproved)
    await getCriterionCs()
  }

  const actionMenuItems = item.is_approved_by_secretariat ? [{
    icon: <RejectIcon />,
    title: 'rejectCriterionC',
    onClick: async () => {
      await handleCriterionCAction({ isApproved: false })
    },
    isDestructive: true
  }] : [{
    icon: <ConfirmIcon />,
    title: 'confirmCriterionC',
    onClick: async () => {
      await handleCriterionCAction({ isApproved: true })
    }
  }]

  const validationCriterionC = siteProposalFieldValidation.criterionC[item.site_ecointegrity_history_id || item.site_ecointegrity_id]
    ? siteProposalFieldValidation.criterionC[item.site_ecointegrity_history_id || item.site_ecointegrity_id]
    : defaultSiteProposalValidationResults.criterionC

  const fieldsToCompleteNumber = Object.values(validationCriterionC).filter((element) => {
    return element === false
  })

  const qulifyes = item.trigger_reason_id?.some((element) => {
    // eslint-disable-next-line no-magic-numbers
    return Number(element) === 1
  })

  const cancelCriterionCsChanges = async (criterionC) => {
    if (!isIndividualUser) {
      showErrorToast('This action is not allowed.')
      return
    }
    const data = await cancelCriterionCReassessmentRequest({ siteId: criterionC.site_history_id, criterionCId: criterionC.site_ecointegrity_history_id, isCancelled: true })
    if (data.error) {
      return showErrorToast(data.error)
    }
    setIsCancelOpen(false)
    setCriterionCToCancel(null)
    toggleAccordion()
    await getCriterionCs()
  }

  const disabled = site.SiteStatusId !== SITE_STATUS_DRAFT_ID || (!isEditable && site.SiteStatusId === SITE_STATUS_DRAFT_ID) || !qulifyes

  return (
    <>
      <EcosystemHeaderNavbarWrapper
        isOpen={isOpen}
        bottomBorder={isOpen || lastItem}
        data-testid='criterionC'
      >
        <EcosystemHeaderNavbarHalfSide onClick={toggleAccordion}>
          <EcosystemHeaderIconWrapper>
            <EcosystemHeaderIcon isRejected={!qulifyes} />
          </EcosystemHeaderIconWrapper>
          <EcosystemHeaderTitle
            isRejected={!qulifyes}
            data-testid='criterionC-name'
            isReassess={item.last_reassessment_date}
          >
            {item?.EcoRegion?.name}
          </EcosystemHeaderTitle>
        </EcosystemHeaderNavbarHalfSide>
        <EcosystemHeaderNavbarHalfSide>
          {site.reassessmentFlag ? (
            <>
              {dateToShow !== '' && (
                <Tooltip
                  style={{ zIndex: 1000 }}
                  placement='top'
                  trigger={['hover']}
                  align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                  overlay={{ label: 'lastTimeReassessed' }}
                >

                  <EcosystemLastReassessmentCalendarWrapper>
                    <EcosystemCalendarIconWrapper>
                      <CalendarIcon />
                    </EcosystemCalendarIconWrapper>
                    <EcosystemCalendarDateText>
                      {dateToShow.toLocaleDateString('en-US', dateOptions)}
                    </EcosystemCalendarDateText>
                    <EcosystemCalendarDivider />
                  </EcosystemLastReassessmentCalendarWrapper>

                </Tooltip>
              )}
              <EcosystemConfirmDeclineIcon type={qulifyes ? 'confirmed' : 'rejected'}>
                {qulifyes ? (
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    placement='top'
                    trigger={['hover']}
                    align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                    overlay={{ label: 'qualifies' }}
                  >
                    <div>
                      <ConfirmIcon />
                    </div>
                  </Tooltip>
                ) : (
                  <Tooltip
                    style={{ zIndex: 1000 }}
                    placement='top'
                    trigger={['hover']}
                    align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                    overlay={{ label: 'nonQualifying', infoTooltip: formattedRejectIconTooltipHint(item).join(', ') }}
                  >
                    <div>
                      <RejectIcon />
                    </div>
                  </Tooltip>
                )}
              </EcosystemConfirmDeclineIcon>
              {site.SiteStatusId === SITE_STATUS_DRAFT_ID ? (
                <>
                  <Button
                    isDisabled={isOpen}
                    type={isOpen ? 'defaultDisabled' : ' '}
                    height='32px'
                    marginTop='0'
                    onClick={toggleAccordion}>
                    <ReassessIcon />
                    <FormattedMessage id={oldTriggers ? 'reassess' : newTriggers ? 'assess' : 'reassess'} />
                  </Button>

                  {oldTriggers && <EcosystemsCancelIconWrapper onClick={(e) => {
                    e.stopPropagation()
                    setCriterionCToCancel(item)
                    setIsCancelOpen(true)
                  }}>
                    <CancelIcon />
                  </EcosystemsCancelIconWrapper>
                  }
                </>
              ) : (
                <>
                  <EcosystemToggleWrapper isActive={isOpen} onClick={toggleAccordion}>
                    <FormattedMessage id='expand' />
                    {isOpen ? <DropdownIndicatorIconOpen /> : <DropdownIndicatorIconClosed />}
                  </EcosystemToggleWrapper>
                </>
              )}
              {(!item.last_reassessment_date && site.SiteStatusId === SITE_STATUS_DRAFT_ID && !disabled) && (
                <>
                  <EcosystemHeaderNavbarIconWrapper
                    delete={true}
                    data-testid='remove-button'
                    onClick={(e) => {
                      e.stopPropagation()
                      openRemoveCriterionCModal(item)
                    }}
                  >
                    <RemoveIcon />
                  </EcosystemHeaderNavbarIconWrapper>
                </>
              )}
              {fieldsToCompleteNumber.length > 0 && (
                <EcosystemValidationIconWrapper>
                  <EcoSystemValidationIcon>
                    <PulsingNotification number={fieldsToCompleteNumber.length} />
                  </EcoSystemValidationIcon>
                </EcosystemValidationIconWrapper>
              )}
            </>
          ) : (
            <>
              <>
                {site.SiteStatusId === SITE_STATUS_DRAFT_ID ? (
                  <Button
                    height='32px'
                    onClick={toggleAccordion}
                    marginTop='0'
                    isDisabled={isOpen}
                    type={isOpen ? 'defaultDisabled' : ''}
                  >
                    <AssessIcon />
                    <FormattedMessage id={oldTriggers ? 'reassess' : newTriggers ? 'assess' : 'reassess'} />
                  </Button>
                ) : (
                  <>
                    {dateToShow !== '' && (
                      <Tooltip
                        style={{ zIndex: 1000 }}
                        placement='top'
                        trigger={['hover']}
                        align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                        overlay={{ label: 'lastTimeReassessed' }}
                      >

                        <EcosystemLastReassessmentCalendarWrapper>
                          <EcosystemCalendarIconWrapper>
                            <CalendarIcon />
                          </EcosystemCalendarIconWrapper>
                          <EcosystemCalendarDateText>
                            {dateToShow.toLocaleDateString('en-US', dateOptions)}
                          </EcosystemCalendarDateText>
                          <EcosystemCalendarDivider />
                        </EcosystemLastReassessmentCalendarWrapper>

                      </Tooltip>
                    )}
                    <EcosystemConfirmDeclineIcon type={qulifyes ? 'confirmed' : 'rejected'}>
                      {qulifyes ? (
                        <Tooltip
                          style={{ zIndex: 1000 }}
                          placement='top'
                          trigger={['hover']}
                          align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                          overlay={{ label: 'qualifies' }}
                        >
                          <div>
                            <ConfirmIcon />
                          </div>
                        </Tooltip>
                      ) : (
                        <Tooltip
                          style={{ zIndex: 1000 }}
                          placement='top'
                          trigger={['hover']}
                          align={{ offset: [tooltipXOffset, tooltipYOffset] }}
                          overlay={{ label: 'nonQualifying', infoTooltip: formattedRejectIconTooltipHint(item).join(', ') }}
                        >
                          <div>
                            <RejectIcon />
                          </div>
                        </Tooltip>
                      )}
                    </EcosystemConfirmDeclineIcon>
                    <EcosystemToggleWrapper isActive={isOpen} onClick={toggleAccordion}>
                      <FormattedMessage id='expand' />
                      {isOpen ? <DropdownIndicatorIconOpen /> : <DropdownIndicatorIconClosed />}
                    </EcosystemToggleWrapper>
                  </>
                )}
              </>
              {site.SiteStatusId === SITE_STATUS_DRAFT_ID && !disabled && (
                <>
                  <EcosystemHeaderNavbarIconWrapper
                    data-testid='remove-button'
                    onClick={(e) => {
                      e.stopPropagation()
                      openRemoveCriterionCModal(item)
                    }}
                  >
                    <RemoveIcon />
                  </EcosystemHeaderNavbarIconWrapper>
                </>
              )}
              {(site.SiteStatusId === SITE_STATUS_NOMINATED_ID && (profile.RoleId === SECRETARIAT_ROLE_ID || profile.RoleId === BIRDLIFE_SECRETARIAT_ROLE_ID)) &&
                <EcosystemActionMenuWrapper>
                  <ActionsMenu table={false} dropdownItems={actionMenuItems} margin='0' />
                </EcosystemActionMenuWrapper>
              }
              {fieldsToCompleteNumber.length > 0 && (
                <EcosystemValidationIconWrapper>
                  <EcoSystemValidationIcon>
                    <PulsingNotification number={fieldsToCompleteNumber.length} />
                  </EcoSystemValidationIcon>
                </EcosystemValidationIconWrapper>
              )}
            </>
          )}
        </EcosystemHeaderNavbarHalfSide>
      </EcosystemHeaderNavbarWrapper>
      <Modal
        width='416px'
        isOpen={isCancelOpen}
        toggleModal={setIsCancelOpen}
        modalTitleId='cancelCriterionCReassessment'
      >
        <FlowRequestModal
          cancelHandler={() => {
            setIsCancelOpen(false)
            setCriterionCToCancel(null)
          }}
          confirmHandler={() => {
            cancelCriterionCsChanges(criterionCToCancel)
          }}
          confirmBtnText='yesCancel'
          rejectBtnText='continueEditing'
          text={<FormattedMessage id='returnDiscardCriterionCChangesText' values={{ criterionCName: <b>{criterionCToCancel?.EcoRegion?.name}</b> }} />}
          item={criterionCToCancel}
          approve={true}
        />
      </Modal>
    </>
  )
}

export default criterionCAccordionHeader